<template>
    <div>
        <!-- <div class="fxn-header-left" :class="($route.path == '/CaseInfo') || ($route.path == '/CaseDetail') ? 'fxn-header-left active' : 'fxn-header-left' " > -->
        <div class="fxn-header-left" v-if="ver_type != '7'">
            <div class="fxn-pull-left" v-if="seat_service == '0'">
                <el-button type="warning" @click="OpenService">开通坐席服务</el-button>
            </div>
            <div class="fxn-pull-left" v-else>
                <div v-show="mem_type == 2">
                    <!-- 无坐席 -->
                    <div v-if="hasSeat == 0">
                        联系本公司运营人员分配坐席
                    </div>
                    <!-- 无坐席 -->
                    
                    <!--有坐席 -->
                    <div v-else>
                        <!-- 联通 -->
                        <div v-show="callLT">
                            <div v-if="!seats && !isaicalling && !$store.getters.iscalling">
                                <el-form :model="TelForm" :rules="TelRules" ref="TelForm">
                                    <el-form-item class="fxn-header-input" label="" prop="phone">
                                        <input class="el-input__inner" type="text" v-model="TelForm.phone" autocomplete="off" maxlength="12" placeholder="请输入电话号码">
                                    </el-form-item>
                                    <div class="fxn-header-button">
                                        <el-button :type="seats ? 'info' : 'success'" style="min-width: 32px;height: 36px;" v-for="(item,index) in seatsObj" :key="index" :icon=" 'iconfont '+'iconphone'+(item.link_type == 2 ? 2 : 1)" @click="submitTel('TelForm',true,item.id,item.link_type, item.voipaccount)"></el-button>
                                        <ShouJiCall :callTo="TelForm.phone" :size="36" />
                                    </div>
                                </el-form>
                            </div>
                            <div v-else-if="$store.getters.iscalling">
                                <i class="el-icon-service"></i>繁忙/通话中
                                <el-button type="primary" style="min-width: 32px;height: 36px;" icon="el-icon-phone" @click="submitExitTel('TelExitForm')">挂机</el-button>
                            </div>
                        </div>
                        <!-- 联通 End -->
                    </div>
                    <!-- 有坐席 End -->
                </div>
            </div>

            <!-- <div class="fxn-Header-Data" v-if="mem_type == '2'">
                <div class="item">总案件：<span>{{TopDatas.case_num}}</span></div>
                <div class="item">总金额：<span>{{TopDatas.case_money | Money}}万</span></div>
                <div class="item">回款金额：<span>{{TopDatas.repay_money | Money}}万</span></div>
                <div class="item">剩余金额：<span>{{TopDatas.surplus_money | Money}}万</span></div>
            </div> -->
        </div>

        <!-- 服务项 -->
        <ServiceItem></ServiceItem>   
        <!-- 服务项 End --> 
    </div>
</template>

<script>
    let ws = '';
    import ServiceItem from './ServiceItem'
    export default {
        components: {
            ServiceItem,
        },
        computed: {
            seats() {
                return this.$store.getters.isseatcalling
            },
            isaicalling() {
                return this.$store.getters.isaicalling
            },
        },
        data(){
            return {
                case_id: '',
                callLT: true,
                hasSeat: '',
                mem_type: '',
                ver_type: '',
                seat_service: '',
                seatzt: '',
                StStatus: {},           //坐席状态
                seatsObj: [],
                TopDatas: [],
                Timer: null,

                //拨打电话
                TelForm: {
                    phone: '',
                    case_id: '',
                },
                TelRules: {
                    phone: [
                        { required: true, message: '请输入呼叫号码', trigger: 'blur' },
                    ]
                },
                isVirtualNumber: false,
                callPhone: '', // 拨打的电话
                bindId: null, // 绑定ID
            }
        },
        methods:{

            //拨打电话
            submitTel(formName, FromTel, seatid, link_type, voipaccount) {
                if (!this.Timer) {
                    this.Timer = setTimeout(() => {
                        if (this.isaicalling || this.$store.getters.iscalling) { //预测式是否通话中 | webrtc是否通话中
                            clearTimeout(this.Timer)
                            this.Timer = null
                            return false
                        }
                        console.log(this.$store.getters.currentSip, voipaccount)
                        if (this.$store.getters.currentSip != voipaccount) {
                            this.$message({
                                message: '该线路坐席未登录，请切换线路坐席!',
                                type: 'warning'
                            })
                            clearTimeout(this.Timer)
                            this.Timer = null
                            return
                        }
                        if (webrtcSDK && this.$store.getters.isRegistered) { //
                            console.log(webrtcSDK)
                            let _this = this

                            _this.callPhone = _this.TelForm.phone;
                            webrtcSDK.callPhone({
                                phone: _this.TelForm.phone, 
                                // encodphone: _this.$options.filters["mobile"](_this.TelForm.phone),
                                // encoding: true
                            })
                        }
                        clearTimeout(this.Timer)
                        this.Timer = null
                    }, 500)
                }
                

            },

            //坐席状态
            SeatStatus(){
                let _this = this
                ws = new WebSocket(this.WebSocketUrl);
                let user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    _this.member_id = user.memberInfo.id
                }
                ws.onopen = function() {
                    ws.send('{"cmd":"seat_msgs","member_id":"'+ _this.member_id +'"}');
                };
                ws.onmessage = function(e) {
                    let seatData = JSON.parse(e.data);
                    _this.StStatus = JSON.parse(e.data);
                    _this.seatzt = seatData.seat_status
                    if (_this.seatzt == '0') {
                        // _this.seats = false
                        _this.$store.commit('call/SET_IS_SEAT_CALLING', false)
                        _this.OpenAside.$emit('toTel','','',false)
                        ws.close();
                    } else {
                        _this.$store.commit('call/SET_IS_SEAT_CALLING', true)
                    }
                };
                ws.onclose = function (event) {
                    console.log(event)
                }          
            },

            //挂机
            submitExitTel() {
                webrtcSDK.endCall()
                // this.post('/osapi/Call/hangUp',{
                //     link_type: localStorage.getItem('link_type')
                // })
                // .then( res=>{
                //    let { msg, code, data } = res.data
                //     if( code !==1 ){
                //         this.$message({
                //             message: msg,
                //             type: 'error'
                //         });
                //     }else{
                //         // this.seats = false;
                //         this.$store.commit('call/SET_IS_SEAT_CALLING', false)
                //         this.OpenAside.$emit('toTel','','',false);
                //         //ws.close();
                //     } 
                // })
            },

            //数据统计
            topData(){
                this.get('/osapi/Cases/casesSelfStatic')
                .then(res=>{
                    let { msg, code, data } = res.data
                    if(code !== 1){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.TopDatas = res.data.data
                    }
                })
            },

            //打开服务窗口
            OpenService(){
                this.OpenAside.$emit('CloseService',true);
            },
        },
        created() {
            this.SeatStatus();
            // let user = JSON.parse(localStorage.getItem('user'));
            // let obj = {
            //     WebSocketUrl: this.WebSocketUrl,
            //     member_id: user.memberInfo.id
            // }
            // this.$store.dispatch('call/initSeatStatusWs', obj)
        },
        mounted(){
            // this.topData();
            //获取已登录用户信息
            let user = JSON.parse(localStorage.getItem('user'));
			if (user) {
                this.hasSeat = user.memberInfo.hasSeat || user.memberInfo.ykWorkPhoneInfo != null;
                this.mem_type = user.memberInfo.mem_type;
                this.seat_service = user.memberInfo.seat_service;
                this.ver_type = user.memberInfo.ver_type;
                this.seatsObj = user.memberInfo.seats;
            }

            if(this.seat_service != 0){
                if (this.hasSeat == 0){

                } else if (this.hasSeat > 0){
                    this.callLT = true;
                } else if (this.hasSeat == 0){
                    this.callLT = false;
                } else {
                    this.callLT = true;
                }
            }

            let that = this;
            this.OpenAside.$on('toTel',function(case_phone,case_id,type,calltype,seatid,link_type){
                if (type && !that.seats  ) {     //如果为拨号并且不在拨号状态中
                    that.TelForm.phone = case_phone;
                    that.TelForm.case_id = case_id;
                    if(calltype == 2){
                        that.callLT = false;
                        that.DYTel();
                    }else{
                        localStorage.setItem('link_type',link_type);
                        that.callLT = true;
                        that.submitTel(case_phone,case_id,seatid,link_type);
                    }
                }
            }) 

            this.OpenAside.$on('webrtcCall', function (case_phone, case_id, contacts_id, voipaccount, custom_params = null, bindId = null) {
                if (!that.$store.getters.iscalling && !that.$store.getters.isaicalling && that.Timer) {
                    clearTimeout(that.Timer)
                    that.Timer = null
                }
                if (!that.Timer) {
                    that.Timer = setTimeout(() => {
                        if (!that.$store.getters.currentSip) {
                            that.$message({
                                message: '坐席未登录，请登陆线路坐席!',
                                type: 'warning'
                            })
                            clearTimeout(that.Timer)
                            that.Timer = null
                            return
                        }
                        if (that.isaicalling || that.$store.getters.iscalling) { //预测式是否通话中 | webrtc是否通话中
                            clearTimeout(that.Timer)
                            that.Timer = null
                            return false
                        }
                        if (that.$store.getters.currentSip != voipaccount) {
                            that.$message({
                                message: '该线路坐席未登录，请切换线路坐席!',
                                type: 'warning'
                            })
                            clearTimeout(that.Timer)
                            that.Timer = null
                            return
                        }
                        let currentSipObj = that.seatsObj.filter(item => item.voipaccount == that.$store.getters.currentSip)

                        let paramsobj = {};
                        if (case_id) {
                            that.case_id = case_id
                            Object.assign(paramsobj, {
                                UID: case_id
                            })
                            // that.get('osapi/Cases/getCall', {
                            //     case_id: case_id
                            // })
                            // if (that.$route.path.indexOf('/CaseInfo') > -1 && case_id != that.$route.params.caseId) { // 操作过上下案件
                            //     that.$router.push({
                            //         path: "/CaseInfo/" + case_id,
                            //         query: {
                            //             id: case_id,
                            //             listId: 0,
                            //             callshow: true,
                            //             detailtype: true,
                            //         },
                            //     });
                            // }
                        } else {
                            that.case_id = ''
                        }

                        if (contacts_id) {
                            Object.assign(paramsobj, {
                                contacts_id: contacts_id
                            })
                        }
                        if (custom_params) {
                            Object.assign(paramsobj, custom_params)
                            if (custom_params.isVirtualNumber) {
                                that.isVirtualNumber = true;
                                that.bindId = bindId;
                            }
                        } else {
                            that.isVirtualNumber = false;
                        }
                        let params = new URLSearchParams(paramsobj).toString()

                        if (
                            webrtcSDK &&
                            that.$store.getters.isRegistered &&
                            currentSipObj.length > 0 &&
                            currentSipObj[0].link_type == 1
                        ) {
                            Promise.all([
                                that.get('osapi/call/getClickCallPrefix'),
                                that.get('osapi/call/getPhoneBelongInfo', {
                                    phone: case_phone
                                })
                            ]).then(res => {
                                let [prefixRes, phoneBelongRes] = res;
                                console.log(prefixRes, phoneBelongRes)
                                if (prefixRes.data.code != 1 || phoneBelongRes.data.code != 1) {
                                    that.$message({
                                        message: prefixRes.data.msg || phoneBelongRes.data.msg,
                                        type: 'warning' 
                                    });
                                } else {
                                    let prefixResData = prefixRes.data.data;
                                    let phoneBelongData = phoneBelongRes.data.data;
                                    let phone = case_phone;
                                    if (prefixResData.excludeCity.indexOf(phoneBelongData.belongInfo.city) < 0) {
                                        phone = prefixResData.prefix + phone;
                                    }
                                    that.callPhone = phone;
                                    webrtcSDK.callPhone({
                                        phone: phone,
                                        params: params
                                    })
                                }
                            }).catch(err => {
                                that.callPhone = case_phone;
                                webrtcSDK.callPhone({
                                    phone: case_phone,
                                    params: params
                                })
                            }).finally(() => {
                                clearTimeout(that.Timer)
                                that.Timer = null
                            })
                        } else {
                            that.callPhone = case_phone;
                            webrtcSDK.callPhone({
                                phone: case_phone,
                                params: params
                            })
                        }
                    })
                }
            })
        },
        beforeDestroy() {
            this.OpenAside.$off('toTel')
            this.OpenAside.$off('webrtcCall')
        },
        watch: {
            seats(val) {
                if (!val) {
                    clearInterval(this.Timer)
                    this.Timer = null;
                } else {
                    this.OpenAside.$emit('toTel','','',true)
                }
            },
            '$store.getters.iscalling'(val) {
                if (!val && this.isVirtualNumber && this.callPhone == this.$store.getters.virtualNumber) {
                    this.get('osapi/unicomrepair/freeCallVirtualAccount', {
                      bindId: this.bindId,
                    }).then(res => {
                      const { code, msg } = res.data;
                      if (code != 1) {
                        this.$message({
                          message: msg,
                          type: "error",
                        });
                      }
                    })
                }
                // if (!val && this.case_id !== '' && this.$store.getters.isAnswer) {
                //     const cur_route = this.$route;
                //     this.$store.dispatch('caseInfoPage/addCuiji', this.case_id);
                //     if (cur_route.path.indexOf('/CaseInfo') > -1) {
                //         if (this.case_id != this.$route.params.caseId) { // 操作过上下案件
                //             this.$router.push({
                //                 path: "/CaseInfo/" + this.case_id,
                //                 query: {
                //                     id: this.case_id,
                //                     listId: 0,
                //                     callshow: true,
                //                     detailtype: true,
                //                 },
                //             });
                //         }
                //     } else {
                //         this.$router.push({
                //             path: "/CaseInfo/" + this.case_id,
                //             query: {
                //                 id: this.case_id,
                //                 listId: 0,
                //                 callshow: true,
                //                 detailtype: true,
                //             },
                //         });
                //     }
                    
                // }
            }
        },
    }
</script>

<style scoped>
    .active{
        left: .75rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tel.vue